import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RetailerPaths from "@faire/retailer-visitor-shared/paths/index";
import { BelongingAtFairePage } from "@faire/retailer-visitor-shared/views/careers/__internal__/BelongingAtFaire/BelongingAtFairePage";
import { FlexibleWorkPolicyPage } from "@faire/retailer-visitor-shared/views/careers/__internal__/FlexibleWorkPolicy/FlexibleWorkPolicyPage";
import { JobOpenings } from "@faire/retailer-visitor-shared/views/careers/__internal__/JobOpenings/JobOpenings";
import { CareersLandingPage } from "@faire/retailer-visitor-shared/views/careers/__internal__/LifeatFaire/CareersLandingPage";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { Route } from "@faire/web-api--source/Route";
import { props as careersRouteProps } from "@faire/web-api--source/routes/careers";
import { props as belongingRouteProps } from "@faire/web-api--source/routes/careers/belonging-at-faire";
import { props as workPolicyRouteProps } from "@faire/web-api--source/routes/careers/flexible-work-policy";
import { props as jobOpeningsRouteProps } from "@faire/web-api--source/routes/careers/openings";
import * as React from "react";
import { Redirect } from "react-router-dom";
export var Careers = function() {
    return /*#__PURE__*/ _jsxs(Switch, {
        children: [
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, belongingRouteProps), {
                component: BelongingAtFairePage
            })),
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, workPolicyRouteProps), {
                component: FlexibleWorkPolicyPage
            })),
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, jobOpeningsRouteProps), {
                component: JobOpenings
            })),
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, careersRouteProps), {
                component: CareersLandingPage
            })),
            /*#__PURE__*/ _jsx(Redirect, {
                to: RetailerPaths.home()
            })
        ]
    });
};
